import { useEffect, useState } from "react";
import { Loading } from "@components";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import * as API from "@api";

export default function NewPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!data) {
      API.Producers.create({
        name: `New Wine Producer`,
        country_id: 1,
      })
        .then((res) => {
          if (!res || res?.error) {
            throw new Error("Error while creating producer");
          }

          setData(res?.data);
        })
        .catch((err) => {
          return message.error(
            err?.message || "Error while creating producer",
            2
          );
        });
    }
  }, [data]);

  if (data?.id) {
    return <Navigate to={`/producers/edit/${data?.id}`} />;
  }

  return <Loading />;
}
